/* ==========================================================================
   ZELICAT THEME — main-cart.js
   Cart page extras on top of cart.js (which does the quantity / remove requests and re-renders [data-cart-render]):
     · pressing Enter in a quantity field no longer reloads the page (the "Update cart" button is only for visitors without JS)
     · keyboard focus goes back to the control that was used after the cart region is re-rendered
   ========================================================================== */
(() => {
  'use strict';
  const ZC = window.ZC;
  if (!ZC) return;
  const { $, $$ } = ZC;

  let last = null;   // { key, role } of the control the visitor used last

  const remember = (e) => {
    const el = e.target.closest('[data-cart-change], input[data-cart-qty], [data-cart-remove]');
    if (!el || !el.closest('[data-main-cart]')) return;
    if (el.hasAttribute('data-cart-remove')) last = { key: el.dataset.cartRemove, role: 'remove' };
    else if (el.hasAttribute('data-cart-change')) last = { key: el.dataset.cartChange, role: 'change' };
    else last = { key: el.dataset.key, role: 'input' };
  };

  ZC.mount(() => {
    if (!ZC.once(document.documentElement, 'main-cart')) return;

    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form[data-cart-form]');
      if (!form) return;
      const submitter = e.submitter;
      if (submitter && submitter.name === 'checkout') return;      // go to checkout
      e.preventDefault();                                          // quantity changes are handled by cart.js
    });

    document.addEventListener('click', remember, true);
    document.addEventListener('change', remember, true);

    document.addEventListener('zc:cart:updated', () => {
      const region = $('[data-main-cart] [data-cart-render]');
      if (!region || !last) return;
      const target = last;
      last = null;
      // the region was just replaced: focus what the visitor was working on, or the nearest useful thing
      let el = null;
      if (target.role !== 'remove') el = $$('input[data-cart-qty]', region).find((i) => i.dataset.key === target.key);
      if (!el) el = $('input[data-cart-qty]', region);
      if (!el) { el = $('.cempty .section-title', region); if (el) el.setAttribute('tabindex', '-1'); }
      if (el) el.focus({ preventScroll: true });
    });
  });
})();
